<template>
  <div class="order-wrapper">
    <div class="order-tabs">
      <div
        v-for="(item, index) in tabs"
        :key="index"
        class="tabs_item"
        @click="chooseItem = item"
        :class="{ tabs_item_active: chooseItem === item }"
      >
        <span class="tab-icon">
          <van-icon :name="getTabIcon(item)" />
        </span>
        {{ item }}
      </div>
    </div>
    <steam-assignment-list v-if="chooseItem === '预约记录'" />
    <div v-else-if="chooseItem === '提卸货订单'">
      <van-tabs v-model="activeName" @change="onClick" sticky>
        <van-tab title="全部" name="all"></van-tab>
        <van-tab title="未完成" name="undo"></van-tab>
      </van-tabs>

      <div class="order-content">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            style="padding-bottom: 20px"
          >
            <div v-for="item in list" :key="item.id" class="order-item">
              <!-- 提货订单 -->
              <div v-if="item.txhlb == '提货'" class="order-card">
                <div class="order-header">
                  <div class="order-type">
                    <van-tag type="primary" size="medium" round>提货</van-tag>
                  </div>
                  <div class="order-date">{{ item.createDate }}</div>
                </div>

                <div class="order-info">
                  <div class="info-item">
                    <span class="info-label">
                      <van-icon name="clock-o" />
                      预约信息:
                    </span>
                    <span class="info-value">{{ item.pdsjd }} 提货口 {{ item.thk }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">
                      <van-icon name="pause-circle-o" />
                      起始时间:
                    </span>
                    <span class="info-value">{{ item.yyqssj }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">
                      <van-icon name="play-circle-o" />
                      终止时间:
                    </span>
                    <span class="info-value">{{ item.yyzzsj }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">
                      <van-icon name="manager-o" />
                      司机:
                    </span>
                    <span class="info-value">{{ item.createName }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">
                      <van-icon name="logistics" />
                      车辆信息:
                    </span>
                    <span class="info-value">{{ item.chetouhao }} {{ item.cheguahao }}</span>
                  </div>
                </div>

                <div class="order-actions" v-if="item.sfky === 'Y'">
                  <router-link :to="{ name: 'orderdetail', params: { id: item.id } }">
                    <van-button type="info" size="small" class="action-btn">订单详情</van-button>
                  </router-link>

                  <router-link
                    v-if="item.sfscdzyd === '1'"
                    :to="{ name: 'uploadth', params: { id: item.id } }"
                  >
                    <van-button type="info" size="small" class="action-btn">
                      上传电子运单
                    </van-button>
                  </router-link>

                  <router-link
                    v-if="item.hsbgshzt === '0'"
                    :to="{ name: 'uploadHealthCode', params: { id: item.yybh } }"
                  >
                    <van-button type="info" size="small" class="action-btn">
                      上传核酸报告
                    </van-button>
                  </router-link>

                  <van-button
                    type="default"
                    size="small"
                    class="action-btn cancel-btn"
                    @click="cancelOrder(item.yybh)"
                  >
                    取消订单
                  </van-button>
                </div>

                <div class="order-actions" v-else>
                  <router-link :to="{ name: 'orderdetail', params: { id: item.id } }">
                    <van-button type="info" size="small" class="action-btn">订单详情</van-button>
                  </router-link>

                  <router-link
                    v-if="item.sfscdzyd === '1'"
                    :to="{ name: 'uploadth', params: { id: item.id } }"
                  >
                    <van-button type="info" size="small" class="action-btn">
                      上传电子运单
                    </van-button>
                  </router-link>
                </div>
              </div>

              <!-- 卸货订单 -->
              <div v-else class="order-card">
                <div class="order-header">
                  <div class="order-type">
                    <van-tag type="success" size="medium" round>卸货</van-tag>
                  </div>
                  <div class="order-date">{{ item.createDate }}</div>
                </div>

                <div class="order-info">
                  <div class="info-item">
                    <span class="info-label">
                      <van-icon name="clock-o" />
                      预约信息:
                    </span>
                    <span class="info-value">{{ item.pdsjd }} 卸货</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">
                      <van-icon name="pause-circle-o" />
                      起始时间:
                    </span>
                    <span class="info-value">{{ item.yyqssj }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">
                      <van-icon name="play-circle-o" />
                      终止时间:
                    </span>
                    <span class="info-value">{{ item.yyzzsj }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">
                      <van-icon name="manager-o" />
                      司机:
                    </span>
                    <span class="info-value">{{ item.createName }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">
                      <van-icon name="logistics" />
                      车辆信息:
                    </span>
                    <span class="info-value">{{ item.chetouhao }} {{ item.cheguahao }}</span>
                  </div>
                </div>

                <div class="order-actions" v-if="item.sfky === 'Y'">
                  <router-link :to="{ name: 'orderdetail', params: { id: item.id } }">
                    <van-button type="info" size="small" class="action-btn">订单详情</van-button>
                  </router-link>
                  <van-button
                    v-if="item.sfscxhzybd === '1'"
                    type="info"
                    size="small"
                    class="action-btn"
                    @click="navToPound(item)"
                  >
                    上传卸货磅单
                  </van-button>
                  <router-link
                    v-if="item.hsbgshzt === '0'"
                    :to="{ name: 'uploadHealthCode', params: { id: item.yybh } }"
                  >
                    <van-button type="info" size="small" class="action-btn">
                      上传核酸报告
                    </van-button>
                  </router-link>

                  <van-button
                    type="default"
                    size="small"
                    class="action-btn cancel-btn"
                    @click="cancelOrder(item.yybh)"
                  >
                    取消订单
                  </van-button>
                </div>

                <div class="order-actions" v-else>
                  <router-link :to="{ name: 'orderdetail', params: { id: item.id } }">
                    <van-button type="info" size="small" class="action-btn">订单详情</van-button>
                  </router-link>
                </div>
              </div>
            </div>

            <!-- 空状态显示 -->
            <div v-if="list.length === 0 && !loading && finished" class="empty-state">
              <van-empty description="暂无订单数据" />
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <steam-appointment-list v-else-if="chooseItem === '蒸洗订单'" />

    <Tabbar></Tabbar>
  </div>
</template>

<script>
import api from '@/fetch/api';
import { Toast, Dialog } from 'vant';
import Tabbar from '../Public/tabbarTpl.vue';
import steamAppointmentList from '@/pages/SteamAppointment/steamAppointmentList.vue';
import steamAssignmentList from '@/pages/SteamAssignment/steamAssignmentList.vue';
export default {
  components: {
    Tabbar,
    steamAssignmentList,
    steamAppointmentList,
  },
  created() {
    document.title = '订单管理';
  },
  activated() {
    // 每次从其他页面返回订单页，默认回到"全部"tab
    this.activeName = 'all';
    this.onRefresh();
  },
  inject: ['reload'],
  methods: {
    // 跳转到磅单上传页面
    async navToPound(item) {
      try {
        const formData = new FormData();
        formData.append('yyid', item.id);
        const res = JSON.parse(await api.ismaigang(formData));
        if (res.respCode === '0') {
          // console.log(res.data);
          // 1马钢, 2纳斯德, 3其他
          this.$router.push({
            name: 'uploadPound',
            params: {
              id: item.id,
              isSpecified: res.data,
              // isSpecified: 3,
              chetouhao: item.chetouhao,
            },
          });
        } else {
          Toast.fail(res.message);
        }
      } catch (error) {
        Toast.fail('网络异常，请稍后再试');
      }
    },
    getTabIcon(tab) {
      switch (tab) {
        case '预约记录':
          return 'clock-o';
        case '提卸货订单':
          return 'logistics';
        case '蒸洗订单':
          return 'filter-o';
        default:
          return 'notes-o';
      }
    },
    onClick() {
      // name, title
      this.onRefresh();
    },
    getNowOrderList() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      that.$data.activeName = 'undo';
      setTimeout(() => {
        that.refreshing = false;
        api
          .getNowOrderList(openid)
          .then(function (resData) {
            var res = JSON.parse(resData);
            if (res.respCode == 0) {
              var dataList = res.data || [];
              that.$data.list = dataList;
              // 按创建时间倒序，最新的在最上面
              that.$data.list.sort(function (a, b) {
                return new Date(b.createDate || 0).getTime() - new Date(a.createDate || 0).getTime();
              });
              that.$data.loading = false;
              if (dataList.length < 10) {
                that.$data.finished = true;
              }
            } else {
              that.$data.loading = false;
              that.$data.finished = true;
            }
          })
          .catch(function (err) {
            that.$data.loading = false;
            that.$data.finished = true;
            console.log(err);
            Toast.fail('连接失败，请刷新页面');
          });
      }, 1000);
    },
    getOrderList() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      that.$data.activeName = 'all';
      var page = that.$data.page;
      api
        .getOrderList(openid, page)
        .then(function (resData) {
          that.refreshing = false;
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            var dataList = res.data || [];
            if (page === 1) {
              that.$data.list = dataList;
            } else {
              that.$data.list = that.$data.list.concat(dataList);
            }
            // 按创建时间倒序，最新的在最上面
            that.$data.list.sort(function (a, b) {
              return new Date(b.createDate || 0).getTime() - new Date(a.createDate || 0).getTime();
            });
            that.$data.loading = false;
            if (dataList.length < 10) {
              that.$data.finished = true;
            }
          } else {
            that.$data.loading = false;
            that.$data.finished = true;
          }
        })
        .catch(function (err) {
          that.$data.loading = false;
          that.$data.finished = true;
          console.log(err);
          Toast.fail('连接失败，请刷新页面');
        });
    },
    onLoad() {
      // 已结束则不再加载；onRefresh 里已经设置 loading=true
      if (this.$data.finished) return;
      var activeName = this.$data.activeName;
      this.$data.page = this.$data.page + 1;
      if (activeName == 'undo') {
        this.getNowOrderList();
      } else {
        this.getOrderList();
      }
    },
    onRefresh() {
      // 防止并发刷新导致接口被重复调用、列表被空数据覆盖
      // activated / van-tabs change / van-list 可能在极短时间内连续触发，用时间戳兜底
      const now = Date.now();
      if (this.$data.loading || now - this.$data.lastRefreshTime < 500) return;
      this.$data.lastRefreshTime = now;
      // 清空列表数据
      this.$data.list = [];
      // 重新加载数据
      this.$data.finished = false;
      // 将 loading 设置为 true，表示处于加载状态
      this.$data.loading = true;
      this.$data.page = 0;
      this.onLoad();
    },
    //取消订单
    cancelOrder(yybh) {
      var that = this;
      if (yybh.length > 0) {
        Dialog.confirm({
          message: '您是否确认要取消订单',
        })
          .then(() => {
            // on confirm
            let formData = new FormData();
            formData.append('yybh', yybh);
            api
              .poststopyy(formData)
              .then(function (resData) {
                var res = JSON.parse(resData);
                if (res.respCode == 0) {
                  that.onRefresh();
                  Toast.success(res.data || '取消成功');
                } else {
                  // 后端返回业务错误（如：该车号今天已取消2次了）用弹窗展示
                  Dialog.alert({ message: res.message || '取消失败' });
                }
              })
              .catch(function (err) {
                console.log(err);
                Toast.fail('连接失败，请刷新页面');
              });
          })
          .catch(() => {
            // on cancel
          });
      }
    },
  },
  data() {
    return {
      chooseItem: '提卸货订单',
      tabs: ['预约记录', '提卸货订单', '蒸洗订单'],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      activeName: 'all',
      page: 0,
      sheetshow: false,
      actions: [{ name: '订单详情' }, { name: '上传' }],
      lastRefreshTime: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.order-wrapper {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 50px;
}
.order-tabs {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 5;
}
.tabs_item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
  margin: 0 4px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  background: #f7f8fa;
  color: #666;
  position: relative;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  .tab-icon {
    margin-right: 4px;
    display: flex;
    align-items: center;
  }
}
.tabs_item_active {
  background: linear-gradient(135deg, #4c8dff, #3e78e7);
  color: #fff;
  box-shadow: 0 3px 8px rgba(76, 141, 255, 0.25);
}

.van-tabs {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.order-content {
  padding: 12px;
}

.order-item {
  margin-bottom: 12px;
}

.order-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  .order-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f5f6f7;

    .order-date {
      font-size: 14px;
      color: #969799;
    }
  }

  .order-info {
    padding: 12px 16px;

    .info-item {
      display: flex;
      margin-bottom: 8px;
      align-items: flex-start;

      &:last-child {
        margin-bottom: 0;
      }

      .info-label {
        width: 90px;
        font-size: 14px;
        color: #969799;
        display: flex;
        align-items: center;

        .van-icon {
          margin-right: 4px;
          font-size: 16px;
        }
      }

      .info-value {
        flex: 1;
        font-size: 14px;
        font-weight: 500;
        color: #323233;
      }
    }
  }

  .order-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    padding: 12px 16px;
    border-top: 1px solid #f5f6f7;

    .action-btn {
      margin-left: 8px;
      margin-bottom: 8px;
      background-color: #4080ff;
      border: none;

      &.cancel-btn {
        background-color: #f7f8fa;
        color: #323233;
        border: 1px solid #e8e8e8;
      }
    }
  }
}

.empty-state {
  padding: 40px 0;
}
</style>
